import React from 'react';

import {daysOfWeek, months} from '#Client/components/constants';
import {
  dateCalendar,
  dateCalendarItem,
  dateCalendarSmall,
  dateCalendarSmallItem,
} from '#Client/components/DateCalendar/DateCalendar.css';

type DateCalendarProps = {
  date: string;
  size?: 'small' | 'large';
};

export const DateCalendar = ({date, size = 'large'}: DateCalendarProps) => {
  const monthIndex = parseInt(date.substring(5, 7), 10) - 1;
  const day = parseInt(date.substring(8, 10), 10);
  const year = parseInt(date.substring(0, 4), 10);
  const dateObj = new Date(year, monthIndex, day);
  const dayOfWeek = daysOfWeek[dateObj.getDay()];
  return (
    <span
      className={`${dateCalendar} ${size === 'small' ? dateCalendarSmall : ''}`}
    >
      <span
        className={size === 'small' ? dateCalendarSmallItem : dateCalendarItem}
      >
        {dayOfWeek}
      </span>
      <span
        className={size === 'small' ? dateCalendarSmallItem : dateCalendarItem}
      >
        {months[monthIndex]}
      </span>
      <span
        className={size === 'small' ? dateCalendarSmallItem : dateCalendarItem}
      >
        {day}
      </span>
    </span>
  );
};
